import * as React from 'react';
import * as styles from './CardItem.module.scss';
import { ArrowUpRightIcon } from '../icons/ArrowUpRightIcon';
import { TagItem } from '../tagItem/TagItem';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

type CardItemProps = {
  imgUrl?: string | null;
  gatsbyImage?: IGatsbyImageData;
  title: string;
  subtitle?: string;
  tags: string[];
  altText?: string | null;
};

const MAX_TAGS_DISPLAYED = 5;

export const CardItem = ({ imgUrl, gatsbyImage, title, subtitle, tags, altText }: CardItemProps) => (
  <div className={styles.cardItem}>
    {gatsbyImage ? (
      <GatsbyImage image={gatsbyImage} alt={altText || ''} className={styles.cardItem__img} />
    ) : (
      <img className={styles.cardItem__img} src={imgUrl} alt={altText || ''} />
    )}
    <div className={styles.cardItem__rightSide}>
      <div className={styles.cardItem__desc}>
        <div className={styles.cardItem__titleAndDate}>
          <p className={styles.cardItem__title}>{title}</p>
          <p className={styles.cardItem__subtitle}>{subtitle}</p>
        </div>
        <div className={styles.cardItem__linkArrow}>
          <ArrowUpRightIcon />
        </div>
      </div>
      {tags && tags.length > 0 && (
        <div className={styles.cardItem__footer}>
          {tags.slice(0, MAX_TAGS_DISPLAYED).map((tag, i) => (
            <TagItem key={tag}>{tag}</TagItem>
          ))}
        </div>
      )}
    </div>
  </div>
);
